export enum OrganizationType {
    CLIENT = 'CLIENT',
    FABRICATOR_MANUFACTURER = 'FABRICATOR_MANUFACTURER',
    MAH = 'MAH',
    IMPORTER = 'IMPORTER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    WHOLESALER = 'WHOLESALER',
    THREE_PL = 'THREE_PL',
    API_SUPPLIER = 'API_SUPPLIER',
    PRIMARY_LABELER = 'PRIMARY_LABELER',
    PRIMARY_PACKAGER = 'PRIMARY_PACKAGER',
    SECONDARY_LABELER = 'SECONDARY_LABELER',
    SECONDARY_PACKAGER = 'SECONDARY_PACKAGER',
    TESTER_RELEASE = 'TESTER_RELEASE',
    TESTER_RELEASE_MICRO = 'TESTER_RELEASE_MICRO',
    TESTER_FULL_TEST = 'TESTER_FULL_TEST',
    TESTER_CONFIRMATORY = 'TESTER_CONFIRMATORY',
    TESTER_ID = 'TESTER_ID',
    TESTER_STABILITY = 'TESTER_STABILITY',
}

// Tester organization types grouped for reuse
export const TESTER_ORGANIZATION_TYPES = [
    OrganizationType.TESTER_RELEASE,
    OrganizationType.TESTER_RELEASE_MICRO,
    OrganizationType.TESTER_FULL_TEST,
    OrganizationType.TESTER_CONFIRMATORY,
    OrganizationType.TESTER_ID,
    OrganizationType.TESTER_STABILITY,
] as const;